import type { InputData } from "../modules/teleop-commands";

function num(v: number): string {
  return (v >= 0 ? "+" : "") + v.toFixed(2);
}

/** One-line live view of the active source's raw data (what goes on the wire). */
export function formatInputPreview(data: InputData | null): string {
  if (!data) return "—";
  if ("keys" in data) return data.keys.length ? data.keys.join(" ") : "ничего не нажато";
  if ("hands" in data) {
    const hands = data.hands
      .map((h) => {
        const side = h.handedness === "left" ? "L" : h.handedness === "right" ? "R" : "?";
        return `${side}: [${h.pressed.join(",")}]`;
      })
      .join("  ");
    return `шлем ${data.head ? "✓" : "—"}  ${hands || "контроллеров нет"}`;
  }
  const axes = data.axes
    .map((v, i) => (Math.abs(v) >= 0.05 ? `a${i}=${num(v)}` : null))
    .filter(Boolean)
    .join(" ");
  const pressed = data.pressed.length ? `кнопки [${data.pressed.join(",")}]` : "";
  return [pressed, axes].filter(Boolean).join("  ") || "ничего не нажато";
}
